import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

const InteractionHintAnimator = ({ showInteractionHint, setShowInteractionHint, orbitControlsRef }) => {
  const startTime = useRef(null);
  const baseAngle = useRef(null);
  const amplitude = 0.16; // rotation range
  const duration = 2000;  // total loop time
  const delay = 300;      // delay before starting

  useFrame(() => {
    const controls = orbitControlsRef.current;
    if (!controls) return;

    if (!showInteractionHint) {
      if (baseAngle.current !== null) {
        controls.setAzimuthalAngle(baseAngle.current);
        controls.update();
      }
      startTime.current = null;
      baseAngle.current = null;
      return;
    }

    if (baseAngle.current === null) {
      baseAngle.current = controls.getAzimuthalAngle();
      startTime.current = Date.now();
      return;
    }

    const elapsed = Date.now() - startTime.current;
    if (elapsed < delay) return;

    const adjustedElapsed = elapsed - delay;

    if (adjustedElapsed > duration) {
      controls.setAzimuthalAngle(baseAngle.current);
      controls.update();
      baseAngle.current = null;
      startTime.current = null;
      setShowInteractionHint(false);

      setTimeout(() => {
          setShowInteractionHint(true);
      }, 2500);

      return;
    }

    const progress = adjustedElapsed / duration;
    const offset = Math.sin(progress * Math.PI * 2) * amplitude;

    controls.setAzimuthalAngle(baseAngle.current + offset);
    controls.update();
  });

  return null;
};

export default InteractionHintAnimator;
